import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        roles: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        roleMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getRolesRequest({dispatch},payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveRoles", null);
            } else {
                dispatch("receivingRoles"); // สถานะ กำลังบันทึก

                // axios.get('/roles').then(res => {
                //
                //     dispatch("receiveRoles", res.data);
                // })

                if (payload.role_master_full!=null){
                    var myArray = payload.role_master_full.split("#");

                    payload.role_group = myArray[0];
                    payload.role_page = myArray[1];
                }else{
                    payload.role_group = '';
                    payload.role_page = '';

                }



                axios.get('/roles', {params: payload})
                    .then(function (res) {
                        dispatch("receiveRoles", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveRoles", null);
                    });

            }
        },
        loadRoleRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveRole", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingRole");
                axios.get('/roles/' + id).then(res => {
                    dispatch("receiveRole", res.data);
                })
            }
        },
        updateRoleRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingRole");
            axios.put('/roles/' + payload.role_id, payload).then(res => {
                dispatch("updateRole", res.data);
            })
        },
        createRoleRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingRole");
            axios.post('/roles', payload).then(res => {
                dispatch("receiveRole", res.data);
            })
        },
        deleteRoleRequest({dispatch}, payload) {

            dispatch("afterDeleteRole", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingRole", payload);

            axios.post('/delete_roles', payload).then(res => {
                dispatch("deleteRole", {role_id: payload.role_id, res: res});
            })


        },
        receiveRoles({commit}, payload) {
            commit("RECEIVED_ROLES", payload)
        },
        receivingRoles({commit}) {
            commit("RECEIVING_ROLES") //call matutions --> state.isReceiving = true;
        },
        receiveRole({commit}, payload) {
            commit("RECEIVED_ROLE", payload)
        },
        receivingRole({commit}) {
            commit("RECEIVING_ROLES") //call matutions --> state.isReceiving = true;
        },
        updateRole({commit}, payload) {
            commit("UPDATED_ROLE", payload)
        },
        updatingRole({commit}) {
            commit("UPDATING_ROLE") //  call matutions --> state.isUpdating = true;
        },
        deleteRole({commit}, payload) {
            commit("DELETED_ROLE", payload)
        },
        deletingRole({commit}, payload) {
            commit("DELETING_ROLE", payload)
        },
        afterDeleteRole({commit}, payload) {
            commit("AFFTER_DELETED_ROLE", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_ROLES(state, payload) {
            state.roles = payload;
            state.isReceiving = false;

        },
        RECEIVING_ROLES(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_ROLE(state, payload) {


            if (payload.role_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let roleMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    roleMessage: (state.roleMessage == roleMessage ? roleMessage + ' ' : roleMessage),

                });
            } else {
                let roleMessage = 'บันทึกสำเร็จ! รายการ ' + payload.role_id + ' ถูกบันทึกแล้ว';
                
                state = Object.assign(state, {
                    roles: [...state.roles, payload],
                    isReceiving: false,
                    errorMessage: false,
                    roleMessage: (state.roleMessage == roleMessage ? roleMessage + ' ' : roleMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_ROLE(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_ROLE(state, payload) {
            let index = state.roles.findIndex(p => p.role_id === payload.role_id);
            let roleMessage = 'บันทึกสำเร็จ! รายการ ' + payload.role_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                roles: state.roles.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                roleMessage: (state.roleMessage == roleMessage ? roleMessage + ' ' : roleMessage),
            })
        },
        UPDATING_ROLE(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_ROLE(state, payload) {


            if (payload.role_id == undefined || payload.res.data.message == 'Relation') {
                let roleMessage= 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.role_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                  
                    roleMessage: (state.roleMessage == roleMessage ? roleMessage + ' ' : roleMessage),

                });
            } else {
                let indexToDelete = state.roles.findIndex(p => p.role_id === payload.role_id);
                let roles = [...state.roles];
                roles.splice(indexToDelete, 1);
                let roleMessage= 'บันทึกสำเร็จ! รายการ ' + payload.role_id + ' ถูกลบแล้ว';
                
                state = Object.assign(state, {
                    roles: [...roles],
                    isDeleting: false,
                    idToDelete: null,
                    roleMessage: (state.roleMessage == roleMessage ? roleMessage + ' ' : roleMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_ROLE(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.role_id;
        },
        AFFTER_DELETED_ROLE(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
